/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
import { ORDER_TYPE_DELIVERY, ORDER_TYPE_PICKUP } from 'shared/constants';
import { GqlDispensaries, GqlOrders_Customer_Emails, GqlUsers } from 'types/graphql';
import { AnalyticsCart, AnalyticsOrder, AnalyticsProduct } from '../../events';

export type CheckoutContext = {
  checkout_token?: string;
  delivery_method?: typeof ORDER_TYPE_DELIVERY | typeof ORDER_TYPE_PICKUP;
  dutchie_pay_enabled?: boolean;
  email?: GqlOrders_Customer_Emails | string | null;
  payment_type?: string | null;
  purchase_type?: string;
  user_enrolled_dutchie_pay?: boolean;
};

export type Payload = CheckoutContext &
  DispensaryContext & {
    data_source?: string | null;
    ecommerce?: any;
    event: string;
    event_action?: string;
    event_category?: string;
    event_label?: string;
    page_path?: string | undefined;
    page_title?: string | undefined;
    page_type?: string | null | undefined;
    page_url?: string | undefined;
    search_term?: string;
  };

// https://developers.google.com/analytics/devguides/collection/ga4/reference/events
// we are sending GA4 events to the GTM container.
export enum GA4_EVENTS {
  addToCart = 'add_to_cart',
  beginCheckout = 'begin_checkout',
  gtmEvent = 'gtm_event',
  purchase = 'purchase',
  removeFromCart = 'remove_from_cart',
  search = 'search',
  selectItem = 'select_item',
  viewCart = 'view_cart',
  viewItem = 'view_item',
  viewListItem = 'view_list_item',
}

export type ActivePath = {
  concrete: string;
  normalized: string;
};

export type ContextCache = {
  activeCart: AnalyticsCart | null;
  activeDispensary: GqlDispensaries | null;
  activePath: ActivePath | null;
  activeUser: GqlUsers | null;
  activeMenuVariant: string;
  activeOrder: AnalyticsOrder | null;
  activePathHasChanged: boolean;
};

export const PRODUCT_RECOMMENDATION = 'Product Recommendation';

type ProductRecommendation = typeof PRODUCT_RECOMMENDATION;

export enum ProductRecommendationSource {
  native = 'Native',
  crossingMinds = 'Crossing Minds',
}

export enum ProductRecommendationSection {
  brand = 'Brand',
  cartRecommendations = 'Cart Recommendations',
  custom = 'Custom',
  itemsOnSale = 'Items on Sale',
  offers = 'Offers',
  oftenPurchasedWith = 'Often Purchased With',
  popularCategory = 'Popular Category',
  popularSubcategory = 'Popular Subcategory',
  relatedItems = 'Related Items',
  staffPicks = 'Staff Picks',
  topSellers = 'Top Sellers',
}

export type CarouselItemListName = `${ProductRecommendation} > ${ProductRecommendationSource} > ${ProductRecommendationSection}`;

export type GTMCartItem = {
  item_id: string;
  item_name: string;
  item_category: string;
  item_list_name?: string | null;
  index?: number | null;
  item_category_2?: string;
  item_variant?: string;
  item_additional_variant?: string;
  item_brand?: string;
  quantity?: string;
  price?: string;
};

export type EcommGTMContext = {
  affiliation?: string;
  currency?: string;
  value?: string;
  item_list_name?: string | null;
};

export type DispensaryContext = {
  dispensary_id?: string;
  dispensary_name?: string;
};

export type CartItem = {
  quantity: number;
  product: AnalyticsProduct;
  option?: string | null | undefined;
};
